import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SelectAudienceComponent } from './audience-select.component';

const components = [SelectAudienceComponent];

@NgModule({
  imports: [CommonModule, TranslateModule, FormsModule],
  declarations: components,
  exports: components
})
export class AudienceModule {}



// WEBPACK FOOTER //
// ./src/app/modules/shared/live-mode/audience/audience.module.ts